import type { AnatomyBinding, AnatomySize } from "./componentAnatomy";

// Mined from the [data-size] blocks in designSystem/Switch/Switch.module.scss.

const geometryNote = "ds-deviation: Figma switch geometry, no token family.";

const sizeGeometry = ({
    trackWidth,
    trackHeight,
    thumbSize,
    travel,
    spinnerSize,
}: {
    trackWidth: string;
    trackHeight: string;
    thumbSize: string;
    travel: string;
    spinnerSize: string;
}): readonly AnatomyBinding[] => [
    {
        partId: "border",
        property: "width",
        literal: trackWidth,
        via: "--switch-track-width",
        note: geometryNote,
    },
    {
        partId: "border",
        property: "height",
        literal: trackHeight,
        via: "--switch-track-height",
    },
    {
        partId: "thumb",
        property: "width",
        literal: thumbSize,
        via: "--switch-thumb-size",
    },
    {
        partId: "thumb",
        property: "travel",
        literal: travel,
        via: "--switch-thumb-travel",
        note: "How far the thumb slides when checked; it stays 2px from the outer edge either side.",
    },
    {
        partId: "spinner",
        property: "width",
        literal: spinnerSize,
        via: "--switch-spinner-size",
        note: "2px inset inside the thumb.",
    },
];

export const switchAnatomySizes: readonly AnatomySize[] = [
    {
        id: "md",
        label: "md",
        selector: '[data-size="md"]',
        bindings: sizeGeometry({
            trackWidth: "36px",
            trackHeight: "20px",
            thumbSize: "16px",
            travel: "16px",
            spinnerSize: "12px",
        }),
    },
    {
        id: "sm",
        label: "sm",
        selector: '[data-size="sm"]',
        bindings: sizeGeometry({
            trackWidth: "28px",
            trackHeight: "16px",
            thumbSize: "12px",
            travel: "12px",
            spinnerSize: "8px",
        }),
    },
];
